import { useState } from 'react';
import lscache from 'lscache';

lscache.setExpiryMilliseconds(1);

export default function useLocalStorageCache(key, initialValue) {
  const [item, setValue] = useState(() => {
    const value = lscache.get(key);
    if (value === null) {
      lscache.set(key, initialValue);
      return initialValue;
    }
    return value;
  });

  const setItem = (newItem, time) => {
    setValue(newItem);
    lscache.set(key, newItem, time);
  };

  return [item, setItem];
}
